// Único punto de verdad para las prioridades de seguimiento ANSES (ALTA/MEDIA/BAJA).
export const PRIORIDADES = [
    { valor: 'ALTA', label: 'Alta', ayuda: 'Revisión frecuente' },
    { valor: 'MEDIA', label: 'Media', ayuda: 'Ritmo normal' },
    { valor: 'BAJA', label: 'Baja', ayuda: 'Revisión espaciada' },
];

// Colores distintivos por nivel, usados en el badge de la lista de Seguimiento de Expedientes.
export const ESTILO_PRIORIDAD = {
    ALTA: { texto: 'Alta', fg: '#991b1b', bg: '#fee2e2', borde: '#ef4444' },
    MEDIA: { texto: 'Media', fg: '#1e40af', bg: '#eff6ff', borde: '#93c5fd' },
    BAJA: { texto: 'Baja', fg: '#166534', bg: '#f0fdf4', borde: '#86efac' },
};
